import { jsx as _jsx } from "react/jsx-runtime";
import { useHistory } from 'react-router-dom';
import { ConfirmationModal, Typography, useOverlayContext } from 'seagull';
import { routes } from '~/constants';
import { useStoreActions } from '~/contexts';
import { useCreateRelationshipFromDraft } from '~/hooks/useCreateRelationshipFromDraft';
import { useSetWorksAtOptimisticUpdate } from '~/hooks/useSetWorksAtOptimisticUpdate';
import { useLocaleKeys } from '~/i18n';
import { errorTextsPath } from '~/infra/ErrorResponse';
import { handleRequest } from '~/infra/utils';
export const useScheduledProposal = (param)=>{
    let { draftId, refresh, onCloseCancelSchedulingModal, isSampleRelationship } = param;
    const { t: scheduledProposalTexts } = useLocaleKeys('hooks.scheduledProposal');
    const { t: commonButtons } = useLocaleKeys('common.buttons');
    const { t: errorTexts } = useLocaleKeys(errorTextsPath);
    const { api } = useStoreActions();
    const history = useHistory();
    const { logBI } = useStoreActions();
    const overlayContext = useOverlayContext();
    const createRelationshipFromDraft = useCreateRelationshipFromDraft();
    const updateWorksAt = useSetWorksAtOptimisticUpdate();
    const sendNow = async ()=>{
        overlayContext.stopLoader('send-now');
        logBI(11353);
        const result = await handleRequest(createRelationshipFromDraft(draftId, {
            isSampleRelationship
        }));
        if (result.success) {
            updateWorksAt(false, false);
            overlayContext.stopLoader('send-now');
            overlayContext.showSuccessToast(scheduledProposalTexts.proposalSentSuccess(), 'send-now-success-toast');
            refresh();
        } else {
            const { text } = result.error.createRelationshipErrorText(errorTexts);
            overlayContext.showErrorToast(text, 'create-relationship-error');
            overlayContext.stopLoader('send-now');
            return;
        }
    };
    const cancelScheduledProposal = async ()=>{
        overlayContext.startLoader('cancel-scheduled-proposal');
        logBI(11354);
        const result = await handleRequest(api.draft.cancelScheduledProposal({
            draftId
        }));
        if (result.success) {
            overlayContext.showSuccessToast(scheduledProposalTexts.schedulingCanceledSuccess(), 'cancel-scheduled-proposal-success-toast');
            overlayContext.stopLoader('cancel-scheduled-proposal');
            refresh();
        } else {
            overlayContext.showErrorToast(result.error, 'cancel-scheduled-proposal-error');
            overlayContext.stopLoader('cancel-scheduled-proposal');
            return;
        }
    };
    const handleCancelSchedulingAndEdit = (dismissModal)=>{
        cancelScheduledProposal();
        dismissModal(true);
        if (history.location.pathname !== routes.draft(draftId)) {
            history.push(routes.draft(draftId));
        }
    };
    const handleCloseCancelSchedulingModal = (dismissModal)=>{
        onCloseCancelSchedulingModal === null || onCloseCancelSchedulingModal === void 0 ? void 0 : onCloseCancelSchedulingModal();
        dismissModal(false);
    };
    const showCancelSchedulingModal = ()=>{
        overlayContext.showModal({
            biName: 'scheduled_proposal_cancel_to_edit_confirm',
            closeOnClickOutside: false,
            closeOnEscapeKey: true,
            content: (param)=>{
                let { dismissModal } = param;
                return /*#__PURE__*/ _jsx(ConfirmationModal, {
                    bi: {
                        primaryButton: {
                            name: 'use_scheduled_proposal_confirm'
                        },
                        secondaryButton: {
                            name: 'use_scheduled_proposal_cancel'
                        }
                    },
                    title: scheduledProposalTexts.cancelToEdit(),
                    skin: "danger",
                    testId: "cancel-scheduling-modal",
                    primaryButtonLabel: scheduledProposalTexts.cancelSchedulingAndEdit(),
                    secondaryButtonLabel: commonButtons.cancel(),
                    onPrimaryButtonClick: ()=>handleCancelSchedulingAndEdit(dismissModal),
                    onSecondaryButtonClick: ()=>handleCloseCancelSchedulingModal(dismissModal),
                    onCloseButtonClick: ()=>handleCloseCancelSchedulingModal(dismissModal),
                    content: /*#__PURE__*/ _jsx(Typography, {
                        children: scheduledProposalTexts.cancelSchedulingContent()
                    })
                });
            }
        });
    };
    return {
        sendNow,
        cancelScheduledProposal,
        handleCancelSchedulingAndEdit,
        showSwitchToEditModal: showCancelSchedulingModal
    };
};
